import { ca } from '@cian/analytics';
import { ESalesType } from '../../types/offersData';

const SALES_TYPE_ANALYTICS = new Map<ESalesType, string>([
  [ESalesType.PromoIndexPage, 'to_promo'],
  [ESalesType.SalesLeader, 'SalesLeaders'],
  [ESalesType.SalesStart, 'SalesStart'],
  [ESalesType.UpcomingSale, 'SalesSoon'],
]);

export function trackSalesLinkClick(salesType: ESalesType): void {
  if (salesType === ESalesType.BlackFriday) {
    ca('eventSite', {
      action: 'click',
      category: 'BlackFriday',
      label: 'selection_banner',
      name: 'oldevent',
    });

    return;
  }

  const gaLabel = SALES_TYPE_ANALYTICS.get(salesType);

  ca('eventSite', {
    action: 'Click',
    category: 'ListingJK',
    label: gaLabel,
    name: 'oldevent',
  });
}

export function trackBlackFridaySalesLinkShow() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'BlackFriday',
    label: 'selection_banner',
    name: 'oldevent',
  });
}
